import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { enumItems } from './enumItems';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SetField } from '../components/Table/fields/SetField';
import { SPSetField } from '../components/Table/fields/SPSetField';

export const accommodationContact: SchemaWithClient<any> = {
  name: 'Contact',
  pluralName: 'Contact',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Full Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    email: {
      name: 'Email',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    alternative_email: {
      name: 'Alternative Email',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    phone: {
      name: 'Phone',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    alternative_phone: {
      name: 'Alternative Phone',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    address: {
      name: 'Address',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    roles: {
      name: 'Roles',
      fieldRenderer: SetField.tableAdapter(enumItems.userType),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.userType),
      url: enumItems.userType.client.getAllPath,
      tempSchema: enumItems.userType,
      multiSwitchboard: true,
    },
    accommodation: {
      name: 'Accommodation Provider',
      fieldRenderer: SelectField.tableAdapter(enumItems.accommodation),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.accommodation
      ),
      url: enumItems.accommodation.client.getAllPath,
      tempSchema: enumItems.accommodation,
      switchboard: true,
    },
    notes: {
      name: 'Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/contacts'),
};
